import React, { PropTypes } from 'react';
import * as B from 'react-bootstrap';
import chatConfiguration from 'config';
import { WEB_RTC_FEATURES } from 'actions/chat/webrtc';
import './styles/chat-header.scss';

const configuration = chatConfiguration.chat;

const HeaderButtons = ({
  agentSupportsWebRTC,
  webRTCStarted,
  allowedWebRTCFeatures,
  preferedVideoMode,
  onStartWebRTC,
  onStartWebRTCInternal,
  onStartChooseCamera,
  onStartFileUpload,
  onMinimize,
  connectionId,
  fileUploadEnabled,
  chooseCamera,
  height,
}) => {
  let buttons = [];
  let buttonStyle = { height: height + 'px' };

  if (fileUploadEnabled) {
    buttons.push(
      <B.Button key="fileupload" bsStyle="link" className="chat-header-btn-right header-tool"
        onClick={onStartFileUpload} style={buttonStyle}
      >
        <B.Glyphicon glyph="paperclip" />
      </B.Button>
    );
  }

  if (connectionId && agentSupportsWebRTC && !webRTCStarted
    && allowedWebRTCFeatures.includes(WEB_RTC_FEATURES.audioOnly)
  ) {
    buttons.push(
      <B.Button key="audio" bsStyle="link" className="chat-header-btn-right" style={buttonStyle}
        onClick={onStartWebRTC.bind(null, onStartWebRTCInternal, connectionId, WEB_RTC_FEATURES.audioOnly )}>
        <B.Glyphicon glyph="earphone" />
      </B.Button>
    );
  }
  if (connectionId && agentSupportsWebRTC && !webRTCStarted
    && allowedWebRTCFeatures.some(f => f === WEB_RTC_FEATURES.twoWayVideo || WEB_RTC_FEATURES.oneWayVideo)
  ) {
    buttons.push(
      <B.Button key="video" bsStyle="link" className="chat-header-btn-right" style={buttonStyle}
        onClick={chooseCamera ? onStartChooseCamera
          : onStartWebRTC.bind(null, onStartWebRTCInternal, connectionId, preferedVideoMode)}
        >
        <B.Glyphicon glyph="facetime-video" />
      </B.Button>
    );
  }

  if (onMinimize) {
    buttons.push(
      <B.Button key="minimize" bsStyle="link" className="chat-header-btn-right chat-header-minimize"
        onClick={onMinimize} style={buttonStyle}
      >
        <B.Glyphicon glyph="minus" />
      </B.Button>
    );
  }

  return <B.ButtonGroup className="chat-webrtc-buttons">{buttons}</B.ButtonGroup>;
};

HeaderButtons.propTypes = {
  onStartWebRTC: PropTypes.func.isRequired,
  onStartWebRTCInternal: PropTypes.func.isRequired,
  onStartChooseCamera: PropTypes.func.isRequired,
  onStartFileUpload: PropTypes.func.isRequired,
  onMinimize: PropTypes.func,
  preferedVideoMode: PropTypes.string.isRequired,
  connectionId: PropTypes.number,
  allowedWebRTCFeatures: PropTypes.array.isRequired,
  agentSupportsWebRTC: PropTypes.bool,
  chooseCamera: PropTypes.bool,
  fileUploadEnabled: PropTypes.bool,
  webRTCStarted: PropTypes.bool.isRequired,
};

const ChatHeader = ({
  onEnd,
  queueProperties,
  webRTCStarted,
  agentSupportsWebRTC,
  allowedWebRTCFeatures,
  onStartWebRTC,
  onStartWebRTCInternal,
  onStartChooseCamera,
  onStartFileUpload,
  onMinimize,
  connectionId,
  height,
  preferedVideoMode,
  chooseCamera,
  fileUploadEnabled,
}) => {
  let headerButtonsProps = { agentSupportsWebRTC, allowedWebRTCFeatures, onStartWebRTC, onStartWebRTCInternal, onStartChooseCamera, onStartFileUpload, connectionId, preferedVideoMode, chooseCamera, fileUploadEnabled, webRTCStarted },
      style = { height: height + 'px' };

  return (
    <div className="chat-header" style={style}>
      <B.Button bsStyle="link" className="chat-end-btn" style={style} onClick={onEnd}>
        {
          configuration.glyphRegEx().test(queueProperties.endButtonLabel)
            ? <B.Glyphicon glyph={configuration.glyphRegEx().exec(queueProperties.endButtonLabel)[1]} />
            : queueProperties.endButtonLabel
        }
      </B.Button>
      <HeaderButtons { ...headerButtonsProps } height={height} onMinimize={onMinimize} />
    </div>
  );
};

ChatHeader.propTypes = {
  ...HeaderButtons.propTypes,
  onEnd: PropTypes.func.isRequired,
  queueProperties: PropTypes.object.isRequired,
};

export default ChatHeader;



// WEBPACK FOOTER //
// ./components/chat/ChatHeader.js